import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { OFFLINE_REPLAY, OfflineSyncService } from './offline-sync.service'

/**
 * Outermost interceptor: while the browser is offline, mutating requests go to
 * the outbox (or are refused with the offline message) instead of failing on
 * the network. Reads pass through to ngsw, which answers them from its cache.
 */
export const offlineQueueInterceptor: HttpInterceptorFn = (req, next) => {
  if (navigator.onLine || req.method === 'GET' || req.method === 'HEAD' || req.context.get(OFFLINE_REPLAY)) return next(req)
  return inject(OfflineSyncService).handleOffline(req)
}
